import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {DriveDataSource} from './data-source/DriveDataSource';
import {ScorecardDataSource} from './data-source/ScorecardDataSource';
import {TrackDetailDataSource} from './data-source/TrackDetailDataSource';
import {DriverDataSource} from './data-source/DriverDataSource';
import {TerminalDataSource} from './data-source/TerminalDataSource';
import {OrganizationDataSource} from './data-source/OrganizationDataSource';
import {GeoFenceDataSource} from './data-source/GeoFenceDataSource';

import {OAuthModule} from 'angular-oauth2-oidc';
import {OAuthConfig} from './oauth.config';
import {AuthenticationService} from './services/authentication.service';
import {IdentityService} from './services/identity.service';
import {SharedModule} from './shared/shared.module';
import {AuthGuard} from './services/auth.guard';
import {UserDataSource} from './data-source/UserDataSource';
import {LayoutModule} from './layout/layout.module';
import {RouterModule} from '@angular/router';
import {InlineSVGModule} from 'ng-inline-svg-2';
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {JwtInterceptor} from "./interceptors/jwt.interceptor";
import {TractorDataSource} from "./data-source/tractor.data-source";
import {TrailerDataSource} from "./data-source/TrailerDataSource";
import {FleetPolicyDataSource} from "./data-source/FleetPolicyDataSource";
import {ImageService} from "./dashboard/image.service";
import {ConfigurationDataSource} from "./data-source/ConfigurationDataSource";
import {FreeTrialDataSource} from "./data-source/FreeTrialDataSource";
import {SubscriptionDataSource} from "./data-source/SubscriptionDataSource";

function oauthInitProvider(oAuthConfig: OAuthConfig, authService: AuthenticationService) {
    return async function () {
        await oAuthConfig.load();

        if (authService.hasValidToken()) {
            authService.init();
            return authService.startupTokenRefresh();
        }

        if (authService.refreshTokenPresent()) {
            try {
                const token = await authService.refreshToken();
                if (token?.access_token && authService.hasValidToken()) {
                    authService.init();
                    return authService.startupTokenRefresh();
                }
            } catch (e) {
                console.log('Unable to refresh user session, manual sign in is needed');
            }
        }
    };
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'ng-cli-universal'}),
        BrowserAnimationsModule,
        OAuthModule.forRoot(),
        SharedModule,
        LayoutModule,
        RouterModule.forRoot([], {enableTracing: false}),
        InlineSVGModule.forRoot()
    ],
    providers: [
        DriveDataSource,
        TractorDataSource,
        TrailerDataSource,
        ScorecardDataSource,
        TrackDetailDataSource,
        DriverDataSource,
        TerminalDataSource,
        OrganizationDataSource,
        GeoFenceDataSource,
        UserDataSource,
        FleetPolicyDataSource,
        OAuthConfig,
        AuthenticationService,
        ImageService,
        ConfigurationDataSource,
        FreeTrialDataSource,
        SubscriptionDataSource,
        {
            provide: APP_INITIALIZER,
            useFactory: oauthInitProvider,
            deps: [OAuthConfig, AuthenticationService],
            multi: true
        },
        AuthGuard,
        IdentityService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
